import React from "react";
import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const DISMISS_KEY = "cloudSyncBanner:dismissed";

const CloudSyncBanner: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const [dismissed, setDismissed] = React.useState<boolean>(false);

  React.useEffect(() => {
    try {
      const v = localStorage.getItem(DISMISS_KEY);
      setDismissed(v === "1");
    } catch {}
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {}
    setDismissed(true);
  };

  if (loading || isAuthenticated || dismissed) return null;

  return (
    <div className="px-4 py-2">
      <Alert className="flex items-start gap-3">
        <Info className="h-4 w-4 mt-0.5 text-primary" aria-hidden="true" />
        <div className="flex-1">
          <AlertTitle>Cloud sync unavailable</AlertTitle>
          <AlertDescription>
            You are not signed in. Autosave to cloud is disabled. Sign in to enable syncing across devices.
          </AlertDescription>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="secondary" asChild>
            <a href="/auth" aria-label="Sign in to enable cloud sync">Sign in</a>
          </Button>
          <Button variant="ghost" onClick={dismiss} aria-label="Dismiss cloud sync banner">Dismiss</Button>
        </div>
      </Alert>
    </div>
  );
};

export default CloudSyncBanner;
